"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertValue = void 0;
const convertValue = (input, conversionRate, decimalPlaces) => {
    const multiplier = 10 ** decimalPlaces;
    return Math.round(input * conversionRate * multiplier) / multiplier;
};
exports.convertValue = convertValue;
